// eslint-disable-next-line import/no-unresolved
import brand from '@brand/brand.js';
import { Trans, useTranslation } from 'react-i18next';
import * as z from 'zod';
import { ProgressLayout } from '../../components/layouts/progress-layout';
import { PatchInviteForm } from '../../components/patch-invite-form';
import { SubmitButton } from '../../components/submit-button';
import { Checkbox } from '../../components/ui/checkbox';
import { InfoBlock } from '../../components/ui/info-block';
import { cleanPhone } from '../../utils/phone';

const schema = z.object({
  acceptedPrivacy: z.literal(true),
});

function extractDefaults({ acceptedPrivacy = false }) {
  return { acceptedPrivacy };
}

function transformValues({ acceptedPrivacy }) {
  return { acceptedPrivacy };
}

export function Privacy(props) {
  const { t } = useTranslation('page.privacy');

  return (
    <PatchInviteForm
      extractDefaults={extractDefaults}
      transformValues={transformValues}
      schema={schema}
      nextPath={props.next.path}
    >
      <ProgressLayout {...props}>
        <h1 className="title">{t('title')}</h1>

        <Trans
          i18nKey="text"
          ns="page.privacy"
          components={{
            p: <p />,
          }}
          values={{ company: brand.company }}
        />

        <InfoBlock className="mb-2.5">
          <h3 className="subtitle mb-0">{t('privacyText')}</h3>
          <Trans
            i18nKey="privacyDetails"
            ns="page.privacy"
            values={brand}
            components={{
              ul: <ul className="pl-6 list-disc" />,
              li: <li />,
            }}
          />
        </InfoBlock>

        <Checkbox name="acceptedPrivacy" label={t('privacyLabel')} />

        <SubmitButton />

        <InfoBlock>
          <Trans
            i18nKey="helpMessage"
            ns="page.privacy"
            values={{ phone: brand.phone }}
            components={{
              h3: <h3 className="subtitle mb-0" />,
              p: <p />,
              br: <br />,
              strong: <strong className="font-semibold" />,
              a: <a href={`tel:${cleanPhone(brand.phone)}`} />,
            }}
          />
        </InfoBlock>
      </ProgressLayout>
    </PatchInviteForm>
  );
}
